import type { ComponentProps } from 'react';
import React from 'react';
import styled from '@emotion/styled';
import type { BorderRadiusProps, DisplayProps, WidthProps } from 'styled-system';
import { borderRadius, display, width } from 'styled-system';

import ResponsiveImage from 'common/components/ResponsiveImage';

interface RecommendationSlideImageProps {
  path: string;
  dataTestId: string;
  alt: string;
  widthConfig: number[];
  isLazy?: boolean;
}

const UnstyledRecommendationImage = styled(ResponsiveImage)<
  ComponentProps<typeof ResponsiveImage> & DisplayProps & WidthProps & BorderRadiusProps
>`
  ${display};
  ${width};
  ${borderRadius};
`;

const RecommendationImage = (props: ComponentProps<typeof UnstyledRecommendationImage>) => (
  <UnstyledRecommendationImage display="block" width="100%" borderRadius="medium" {...props} />
);

const RecommendationSlideImage = ({
  path,
  alt,
  dataTestId,
  widthConfig: widths,
  isLazy,
}: RecommendationSlideImageProps) => {
  return (
    <RecommendationImage
      data-testid={dataTestId}
      alt={alt}
      src={path}
      isLazy={isLazy}
      {...(widths ? { widths } : {})}
    />
  );
};

export default RecommendationSlideImage;
